(function(){
  var KEY = 'bkArtVaultV2';
  var LEGACY_KEYS = ['bkArtVaultV2','bkArtVault','BK_ART_VAULT','bk_heartopedia_art','bkTeenArtVault','bk_brave_art_vault','bkColoringVault'];

  function parse(raw, fallback){
    try {
      return raw ? JSON.parse(raw) : fallback;
    } catch(e){
      return fallback;
    }
  }

  function getImage(item){
    if(!item) return '';
    if(typeof item === 'string') return item;
    return item.image || item.imageUrl || item.dataUrl || item.src || item.url || item.thumb || '';
  }

  function hash(s){
    var h = 0;
    var i = 0;
    for(i = 0; i < String(s).length; i++){
      h = ((h << 5) - h) + String(s).charCodeAt(i);
      h |= 0;
    }
    return h;
  }

  function normalize(item, index){
    var img = getImage(item);
    if(!img) return null;

    var title = (item && typeof item === 'object' && (item.title || item.name || item.label)) || ('Heartopedia Art ' + (index + 1));
    var hub = (item && typeof item === 'object' && (item.hub || item.ageHub || item.source)) || 'Heartopedia';

    return {
      id: (item && item.id) || ('art-' + index + '-' + Math.abs(hash(img))),
      title: title,
      hub: hub,
      image: img,
      createdAt: (item && item.createdAt) || Date.now()
    };
  }

  function rawReadKey(key){
    var data = parse(localStorage.getItem(key), []);

    if(Array.isArray(data)) return data;
    if(Array.isArray(data.items)) return data.items;
    if(Array.isArray(data.art)) return data.art;
    if(Array.isArray(data.images)) return data.images;

    return [];
  }

  function read(){
    var collected = [];

    LEGACY_KEYS.forEach(function(key){
      collected = collected.concat(rawReadKey(key));
    });

    var seen = {};

    return collected
      .map(normalize)
      .filter(Boolean)
      .filter(function(item){
        if(seen[item.image]) return false;
        seen[item.image] = true;
        return true;
      });
  }

  function write(items){
    items = (items || []).map(normalize).filter(Boolean);
    localStorage.setItem(KEY, JSON.stringify(items));

    window.dispatchEvent(new CustomEvent('bk:artvault:update', {
      detail: items
    }));

    return items;
  }

  function add(item){
    var items = read();
    items.push(item);
    return write(items);
  }

  function remove(id){
    return write(read().filter(function(item){
      return item.id !== id;
    }));
  }

  window.BKArtVaultV2 = {
    key: KEY,
    read: read,
    write: write,
    add: add,
    remove: remove,
    normalize: normalize
  };

  if(!window.BKArtVault) {
    window.BKArtVault = window.BKArtVaultV2;
  }
})();